import React from 'react';
import FadeIn from '../components/atoms/FadeIn';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import brand from '@lib/brand';
import { Wrapper } from '@molecules/MDXWrapper';
import { PrivacyHTMLContent } from '@content/privacy';

function PrivacyPage() {
  return (
    <FadeIn>
      <Head>
        <title>{brand.brand} | Privacy</title>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </Head>
      <Wrapper>
        <div
          dangerouslySetInnerHTML={{
            __html: PrivacyHTMLContent
          }}></div>
      </Wrapper>
    </FadeIn>
  );
}

export default PrivacyPage;
